<template>
	<div id="app">
		<transition name="router-transition">
			<router-view/>
		</transition>

		<nav class="app-nav">
			<router-link to="/impressum">Impressum</router-link>
			<router-link to="/datenschutz">Datenschutzerklärung</router-link>
		</nav>
	</div>
</template>

<script>
export default {
	name: 'App'
}
</script>

<style lang="scss">
$color-brand: #3bd3b2;

*,
*:before,
*:after {
	box-sizing: border-box;
}

body {
	display: flex;
	flex-flow: column nowrap;
	justify-content: flex-end;
	padding: 2rem;
	margin: 0;
	height: 100vh;
	transform-perspective: 10px;
	background-color: $color-brand;
	font-size: 10px;
	font-weight: bold;
	font-family: monospace;
	line-height: 1.4;
}

.app-nav {
	a {
		color: white;
		display: block;
		text-align: center;
		margin: auto auto auto 0;
		padding: 0.25rem;
	}
}

.router-transition {
	&-enter-active,
	&-leave-active {
		transition: opacity 0.5s;
	}
	&-enter,
	&-leave-to {
		opacity: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue